// Added By Divyesh
// Added By MLVeda
// Financing
class GlaceModal extends HTMLElement {
  constructor() {
    super();
    this.handleUnderstood = this.handleUnderstood.bind(this);
    this.handleClearCart = this.handleClearCart.bind(this);
  }

  connectedCallback() {
    this.btnUnderstood = this.querySelector('.btn-understood');
    this.btnClearCart = this.querySelector('.btn-clear-cart');

    this.btnUnderstood?.addEventListener('click', this.handleUnderstood);
    this.btnClearCart?.addEventListener('click', this.handleClearCart);
  }

  disconnectedCallback() {
    this.btnUnderstood?.removeEventListener('click', this.handleUnderstood);
    this.btnClearCart?.removeEventListener('click', this.handleClearCart);
  }

  open() {
    this.classList.add('active');
  }

  close() {
    this.classList.remove('active');
  }

  handleUnderstood() {
    this.close();
  }

  async handleClearCart() {
    if (!this.btnClearCart) return;

    try {
      // ✅ SHOW LOADER
      this.btnClearCart.classList.add('loading');

      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      window.location.reload();

    } catch (error) {
      console.error('Error clearing cart:', error);

      // ❌ remove loader if error
      this.btnClearCart.classList.remove('loading');
    }
  }
}

if (!customElements.get('glace-modal')) {
  customElements.define('glace-modal', GlaceModal);
}

class ValidateCart extends HTMLElement {
  connectedCallback() {
    this.handleCartValidation();
  }

  async handleCartValidation() {
    try {
      const script = this.querySelector('script[type="application/json"]');
      if (!script) return;
      
      let updates;
      try {
        updates = JSON.parse(script.textContent.trim());
      } catch (err) {
        console.error('Invalid JSON inside <validate-cart>', err);
        return;
      }
      
      // Reorder feature
      const params = new URLSearchParams(window.location.search);
        
      if (!updates || !Object.keys(updates).length || params.has("cart_link_id")) return;
      console.log(updates)
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      // Optional event trigger
      document.dispatchEvent(new CustomEvent('cart:updated'));

      // for (const key in updates) {
      //   const cart_item = document.querySelector(`interactive-cart cart-item[key="${key}"]`);

      //   if (cart_item) {
      //    cart_item.remove();
      //   }
      // }
      window.location.reload()
    } catch (error) {
      console.error('ValidateCart error:', error);
    }
  }
}

customElements.define('validate-cart', ValidateCart);


// Added By Divyesh
if (!customElements.get('system-cart-check')) {
  customElements.define('system-cart-check', class extends HTMLElement {
    constructor() {
      super();
      // Bind once to ensure 'this' context is correct and we can remove it if needed
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.loginRequired = this.hasAttribute("required_login");
    }

    connectedCallback() {
      this.button = this.querySelector('button, a, [type="submit"]');
      this.modal = document.querySelector('cart-restriction-modal');
      this.redirectTo = this.getAttribute("data-redirect");
      this.emiPlan = this.getAttribute("data-plan")
      if (this.button) {
        this.button.addEventListener('click', this.handleButtonClick);
      }

      // Close logic for "Understood" button
      this.querySelectorAll('[data-close-modal]').forEach(btn => {
        btn.addEventListener('click', () => this.closeModal());
      });
    }

    async handleButtonClick(e) {
      // 1. Stop the default action (form submit, link follow, etc.)
      e.preventDefault();
      
      // 2. Stop the click from reaching parent elements/theme scripts
      e.stopPropagation();

      this.button.setAttribute('aria-busy', true);
      

      if(this.emiPlan){
        localStorage.setItem("emiPlan", this.emiPlan);
      }

      // check for Cart validation
      const canCustomerProceedWithFinance = await this.canCustomerProceedWithFinance();
      if(!canCustomerProceedWithFinance){
        // check for emi-calculator page if product not added to cart and product form is found
        const productForm = this.querySelector("product-form form")
        if(productForm){
          productForm.dispatchEvent(new Event("submit"));
          this.button.removeAttribute('aria-busy');
          return;
        }
        // 3. Open your custom modal
        this.openModal();
        this.button.removeAttribute('aria-busy');
        return;
      }

      if(this.loginRequired && this.emiPlan != "Full Pay"){
        const returnTo = encodeURIComponent(theme.financing_form_link);
        const href = `/customer_authentication/login?return_to=${returnTo}`;
        window.location.href = href;
        return;
      }

      // redirect to finance form If selected plan is not a full plan
      if(this.emiPlan != "Full Pay"){
        if(this.redirectTo && this.redirectTo.trim() != "#" && this.redirectTo.trim() != ""){
          window.location.href = this.redirectTo;
        }else{
          window.location.href = theme.financing_form_link;
        }
      }else{
        window.location.href = "/cart";
      }
    }

    openModal() {
      if (this.modal) {
        if(this.modal.querySelector(".btn-login-now")){
          const loginLink = this.modal.querySelector(".btn-login-now");
          loginLink.href = `${loginLink.href}`;
        }
        this.modal.classList.add('active');
        document.body.style.overflow = 'hidden'; 
      }
    }

    closeModal() {
      this.modal.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      document.documentElement.style.overflow = '';
    }

     async canCustomerProceedWithFinance(){
        // check if any system or PTO type available in cart  
        const currentCart = await fetch('/cart.js').then(res => res.json());;
        const cartItems = currentCart.items;
        let returnValue = false;

        if(cartItems && cartItems.length > 0){
            for (const item of cartItems) {
              const productType = item.product_type?.trim().toLowerCase()
                if(productType == "system" || productType == "pto"){
                  returnValue = true;
                  break;
                }
            }
        }else{
            returnValue = false;
        }

        return returnValue;
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.handleButtonClick);
      }
    }
  });
}

if (!customElements.get('cart-restriction-modal')) {
  customElements.define('cart-restriction-modal', class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {

      this.modal =this;
      // Close logic for "Understood" button
  this.querySelectorAll('[data-close-modal]').forEach(btn => {
    btn.addEventListener('click', () => this.closeModal());
  });
    }

    

    closeModal() {
      this.modal.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      document.documentElement.style.overflow = 'unset';
      document.body.style.overflow =''
    }

  });
}

  class AddressAutocomplete extends HTMLElement {
    constructor() {
      super();
      this.debounceTimer = null;
    }

    connectedCallback() {
      // Find elements inside this component
      this.input = this.querySelector('[data-address="line1"]');
      this.loader = this.querySelector('[data-address="loader"]');
      this.suggestionBox = this.querySelector('[data-address="suggestions"]');

      this.street2 = this.querySelector('[data-address="line2"]');
      this.city = this.querySelector('[data-address="city"]');
      this.state = this.querySelector('[data-address="state"]');
      this.postal = this.querySelector('[data-address="postal"]');
      this.country = this.querySelector('[data-address="country"]');

      this.baseUrl = `https://www.mlveda.com/ShopifyApps/candelaAPI/api/address/suggest`

      this.attachEvents();
    }

    debounce(fn, delay) {
      return (...args) => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => fn(...args), delay);
      };
    }

    async fetchSuggestions(query) {
  try {
    const country = this.country?.value || "US";

    if (!query.trim()) {
      this.renderSuggestions([]);
      return;
    }

    // OPTIONAL: cancel previous request (important for fast typing)
    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    const res = await fetch(
      `${this.baseUrl}?q=${encodeURIComponent(query)}&country=${country}`,
      {
        signal: this.abortController.signal,
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    if (!res.ok) {
      throw new Error("Autocomplete API failed");
    }

    const data = await res.json();
    console.log("Data from MY Endpoint: ", data)
    // 👇 adapt this depending on your API response
    const suggestions = data.suggestions || [];

    this.renderSuggestions(suggestions);

  } catch (error) {
    // Ignore abort errors (user typing fast)
    if (error.name === "AbortError") return;

    console.error("Autocomplete error:", error);
    this.renderSuggestions([]);
  } finally {
    this.loader.style.display = 'none';
  }
}

    renderSuggestions(list) {
      this.suggestionBox.innerHTML = '';

      if (!list.length) {
        this.suggestionBox.style.display = 'none';
        return;
      }

      list.forEach((item) => {
        const div = document.createElement('div');
        div.className = 'suggestion-item';
        div.textContent = item.label;

        div.addEventListener('click', () => {
          const addr = item.formattedAddress;

          this.input.value = addr.address1 || '';
          this.street2.value = addr.address2 || '';
          this.city.value = addr.city || '';
          this.postal.value = addr.zip || '';

          if (addr.provinceCode) {
            this.state.value = addr.provinceCode;
          }

          this.suggestionBox.style.display = 'none';
          this.state.dispatchEvent(new Event("change"))
        });

        this.suggestionBox.appendChild(div);
      });

      this.suggestionBox.style.display = 'block';
    }

    attachEvents() {
      const debouncedFetch = this.debounce((value) => {
        this.fetchSuggestions(value);
      }, 400);

      this.input.addEventListener('input', (e) => {
        const value = e.target.value.trim();

        if (!value) {
          this.loader.style.display = 'none';
          this.suggestionBox.style.display = 'none';
          return;
        }

        this.loader.style.display = 'block';
        debouncedFetch(value);
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.suggestionBox.style.display = 'none';
        }
      });
    }
  }

  // async function fetchSuggestions(query) {
  //     if (!query) {
  //       suggestionBox.style.display = 'none';
  //       return;
  //     }

  //     loader.style.display = 'block';

  //     try {
  //       // 👉 Replace with your actual API
  //       const res = await fetch(`/your-api?q=${encodeURIComponent(query)}`);
  //       const data = await res.json();

  //       renderSuggestions(data.suggestions || []);
  //     } catch (err) {
  //       console.error(err);
  //     } finally {
  //       loader.style.display = 'none';
  //     }
  //   }

  customElements.define('address-autocomplete', AddressAutocomplete);


  import { debounce, formatMoney } from "utils";

  class FinanceForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector("form");

        if (!this.form) {
          console.warn("FinanceForm: No form found inside component.");
          return;
        }

        if(localStorage.getItem("emiPlan") === 'Full Pay'){
          localStorage.setItem('emiPlan', '12 Months')
        }

        this.container = this.closest("#financeAppWrapper");
        this.financeApp = this.container.querySelector('#FinanceApp');
        // Finance information
        this.financeAppInfo = document.querySelector('.finanace-info-wrapper');
        if(this.container){
          this.step1Tab = this.container.querySelector('.finance-step[data-step="1"]');
          this.step3Tab = this.container.querySelector('.finance-step[data-step="3"]');
          this.step4Tab = this.container.querySelector('.finance-step[data-step="4"]');

  
          this.step1Content = this.container.querySelector('.finance-step-content[data-step="1"]');
          // Sucess message
          this.step3Content = this.container.querySelector('.finance-step-content[data-step="3"]');
          // DEXT form
          this.step4Content = this.container.querySelector('.finance-step-content[data-step="4"]');
          // Pending state
          this.step5Pending = this.container.querySelector('.finance-step-content[data-step="5"]');
          // Rejected state
          this.step6Rejected = this.container.querySelector('.finance-step-content[data-step="6"]');
          // Docusign state
          // this.step7Docusign = this.container.querySelector('.finance-step-content[data-step="7"]');

          // Page title
          this.pageTitle = document.querySelector("h1.section__title-text");


          this.response = null;

          this.emiPlan = this.container.querySelector("#FinanceApp .emi-plan .selected-emi-plan");
          // Down payment
          // this.downPayment = this.container.querySelector("#FinanceApp .emi-plan-downpayment .selected-downpayment-plan");
          // this.cartDownpayment = this.container.querySelector(".cart-downpayment");
          // this.downPaymentPercentage = 0;


          if(this.emiPlan){
            const emiPlan = localStorage.getItem("emiPlan");
            const term = Number(emiPlan.split(" ")[0]) || 12;
            const rate = term === 12 ? 0 : 6.99;
            const text = `${emiPlan} x ${rate}% APR` 
            this.emiPlan.innerText = text;
          }

          // Down payment
          // if(this.downPayment){
          //   if(localStorage.getItem("emiPlan") == "12 Months"){
          //     this.downPayment.innerText = localStorage.getItem("downpayment");
          //     this.downPaymentPercentage = Number(localStorage.getItem("downpayment")?.split("%")[0] ?? 0)
          //   }else{
          //     this.downPayment.parentNode.setAttribute("hidden", true);
          //     this.cartDownpayment.setAttribute("hidden", true);

          //   }
          // }

          this.cartSummaryWrapper = this.container.querySelector("aside.cart-custom-wrapper")

          // Add shipping charge product
            this.shippingCartLineKey = null;

            fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                updates: {
                  [47396781916322]: 1,
                },
                attributes:{
                  Financing: null,
                }
              }),
            })
            .then((response) => response.json())
            .then((cart) => {
              const shippingCartLine = cart.items.find((item) => item.id === 47396781916322);
              if(shippingCartLine){
                this.shippingCartLineKey = shippingCartLine.key;
              }
            })
            .catch((error) => {
              console.error("Error updating cart:", error);
            });
          }


        this.shippingCalculated = false;
        this.submitBtn = this.form.querySelector('[type="submit"]');
        this.requiredInputsForShipping = this.form.querySelectorAll(".required-for-shipping");
        this.shippingSection = this.querySelector('.shipping-method-section');
        this.taxAmount = 0;
        this.shippingAmount = 0;
        this.totalInterest = 0;

        const subtotalElement = document.querySelector(".cart-custom-summary-val");
        console.log("subtotalElement: ",subtotalElement)
        if (subtotalElement) {
          this.total = Number(subtotalElement.textContent.replace(/[^0-9.]/g, ""));
        }

        this.baseUrl = `https://www.mlveda.com/ShopifyApps/candelaFinanceAPI`

        switch (window.location.hostname) {
          case 'candela-medical-shop-fusion.myshopify.com':
            this.baseUrl = 'https://www.mlveda.com/ShopifyApps/CandelaFinanceFusionTest';
            break;
        
          default:
            break;
        }

        // Modal
        this.modal = document.querySelector('#process-modal');
        this.errorBox = document.querySelector('#error-message');

        this.steps = {
          inputs: document.querySelector('#step-inputs'),
          cart: document.querySelector('#step-cart'),
          // taxAndShipping : document.querySelector('#step-shipping-tax'),
          submit: document.querySelector('#step-submit'),
        };

        this.modal.querySelector('.glace-modal-close')
          ?.addEventListener('click', () => this.closeModal());

        this.modal.querySelector('.glace-modal-overlay')
          ?.addEventListener('click', () => this.closeModal());

        this.form.addEventListener("submit", (e) => this.handleSubmit(e));

        this.form.querySelectorAll('[data-required="true"]').forEach((field) => {
          field.addEventListener("input", () => {
            if (field.value.trim()) {
              field.classList.remove("field-error");
            }
          });
          field.addEventListener("change", () => {
            if (field.value.trim()) {
              field.classList.remove("field-error");
            }
          });
        });

        this.inputsRequiredForCalculation = this.querySelectorAll(".required-for-shipping");
        this.inputsRequiredForCalculation.forEach(input => {
          input.addEventListener("change", (e) => this.calculateTaxAndShipping());
        });

        this.updateCost();
        this.calculateTaxAndShipping();

        // Dext form submission message
        window.addEventListener("message", (event) => {
          // console.log("Message from iframe:", event.data);
          // statusEl.innerText = `Message received: ${JSON.stringify(event.data)}`;

          // Check submitted event
          if (event.data?.type === "dx-form-submitted") {
            console.log("Form submitted successfully");

             // --- GA4 supplemental_application_submit tracking ---
            // Fires regardless of outcome — triggered as soon as the
            // Dext Capital iframe posts back the "form submitted" message.
            try {
              const pushData = {
                event: 'supplemental_application_submit'
              };

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push(pushData);

              // console.group('%c✅ GA4 EVENT: supplemental_application_submit', 'background: #27ae60; color: #fff; padding: 2px 5px; font-weight: bold;');
              // console.log('Payload Pushed:', pushData);
              // console.log('Current dataLayer:', window.dataLayer);
              // console.groupEnd();

            } catch (err) {
              console.error('❌ GA4 supplemental_application_submit Error:', err);
            }
            // --- end GA4 tracking ---

            // // Hide step 4
            // if (this.step4Content) {
            //   this.step4Content.classList.remove("active");
            // }

            // // Show pendind state for not approved

            // if(this.response && !this.response.decision && this.step5Pending){
            //   this.step5Pending.classList.add("active");
            // }

            // // Show step 3 - success
            // if(this.response.decision){ 
            //   if (this.step3Content && this.step3Tab) {
            //     this.step3Content.classList.add("active");
            //     this.step3Tab.classList.add("active");
            //   }
            // }
            // // Scroll to top
            // window.scrollTo({ top: 0, behavior: "smooth" });

            window.location.href = "/pages/docusign-completed";

            const warning = document.querySelector(".finance-info-box");
            if(warning){
              warning.setAttribute("hidden", true);
            }

          }
        });
      }

      updateCost(){
        // this.displayInterestRate();
        // this.displayFinancingAmount()
      }

      displayInterestRate() {

        // -----------------------------
        // GET TOTALS
        // -----------------------------
        const totalElement = document.querySelector(".cart-custom-total-price");

        const parsedCartTotal = totalElement
          ? Number(totalElement.textContent.replace(/[^0-9.]/g, ""))
          : 0;

        const total = Number(this.total || parsedCartTotal || 0);
        const taxAmount = Number(this.taxAmount || 0);
        const shippingAmount = Number(this.shippingAmount || 0);

        // -----------------------------
        // EMI PLAN
        // -----------------------------
        const emiPlan = localStorage.getItem("emiPlan") || "";
        const term = Number(emiPlan.split(" ")[0]) || 12;

        // 12 months = 0%
        const rate = term === 12 ? 0 : 6.99;

        // -----------------------------
        // CALCULATE LOAN AMOUNT
        // -----------------------------
        //const principal = total + taxAmount + shippingAmount;
        const principal = total + taxAmount;

        let monthlyPayment = 0;
        let totalCost = 0;
        let totalInterest = 0;

        // -----------------------------
        // EMI CALCULATION
        // -----------------------------
        if (rate === 0) {
          // No interest case
          monthlyPayment = principal / term;
          totalCost = principal;
          totalInterest = 0;
        } else {
          const monthlyRate = rate / 100 / 12;

          // EMI Formula
          monthlyPayment =
            (principal *
              monthlyRate *
              Math.pow(1 + monthlyRate, term)) /
            (Math.pow(1 + monthlyRate, term) - 1);

          totalCost = monthlyPayment * term;
          totalInterest = totalCost - principal;
        }

        this.totalInterest = totalInterest;

        // -----------------------------
        // ROUND VALUES
        // -----------------------------
        monthlyPayment = Number(monthlyPayment.toFixed(2));
        totalCost = Number(totalCost.toFixed(2));
        totalInterest = Number(totalInterest.toFixed(2));

        // -----------------------------
        // DEBUG LOGS
        // -----------------------------
        console.log("Finance Calculation:", {
          principal,
          taxAmount,
          shippingAmount,
          term,
          rate,
          monthlyPayment,
          totalCost,
          totalInterest,
        });

        // -----------------------------
        // UPDATE UI
        // -----------------------------
        const interestElement =
          this.container.querySelector(".cart-total-interest");

        if (interestElement) {
          interestElement.innerText = formatMoney(
            totalInterest * 100,
            window.theme.money_total_price_format
          );
        }

        const interestPercentageElement =
          this.container.querySelector(".interest-rate");

        if (interestPercentageElement) {
          interestPercentageElement.innerText =
            rate === 0 ? "(0% APR)" : `(${rate}% APR)`;
        }

        const monthlyPaymentElement =
          this.container.querySelector(".monthly-payment");

        if (monthlyPaymentElement) {
          monthlyPaymentElement.innerText = formatMoney(
            monthlyPayment * 100,
            window.theme.money_total_price_format
          );
        }

        const totalCostElement =
          this.container.querySelector(".finance-total-cost");

        if (totalCostElement) {
          totalCostElement.innerText = formatMoney(
            totalCost * 100,
            window.theme.money_total_price_format
          );
        }
      }

      displayFinancingAmount(){

        const finalAmount = this.total + this.taxAmount + this.shippingAmount + this.totalInterest;
        const financeAmountElement = this.container.querySelector(".cart-custom-finance-price");
        if(financeAmountElement){
          financeAmountElement.textContent = formatMoney(finalAmount*100,  window.theme.money_total_price_format);
        }
      }

      // ================= FORM SUBMISSION =================

      async handleSubmit(e) {
        e.preventDefault();

        const isValid = this.validateRequiredFields();

        if (!isValid) return;

        this.resetSteps();
        this.openModal();
        this.setLoading(true);

        

        try {
          // ================= STEP 1: INPUT VALIDATION =================
          this.validateInputs();
          this.setStepSuccess(this.steps.inputs);

          // ================= STEP 2: CART =================
          const cart = await this.validateCart()
          this.setStepSuccess(this.steps.cart);


          // ================= BUILD DATA =================
          const equipment = cart.items.map(item => {

            const model = this.container.querySelector(`.${item.handle}`)?.dataset.model;
            return {
            make: item.vendor,
            model: item.properties["_model"] ?? model,
            serialNumber: item.sku,
            handle: item.handle,
            id:String(item.id),
            price: item.discounted_price / 100,
            cost: (item.line_price / 100),
            quantity: item.quantity,
            originalPrice:item.original_price/100,
            discountedPrice:item.discounted_price/100
          }});

          // Add shipping charge line item:
          const selectedDefaultInput = this.querySelector('input[name="shipping_method"]:checked'); 
          if(selectedDefaultInput){
            // equipment.push({
            //   make:"candela",
            //   model:"charge",
            //   handle:"shipping-charges",
            //   id:"59490997665873",
            //   quantity:1,
            //   price: Number(this.shippingAmount),
            //   cost: Number(this.shippingAmount),
            // })

          }else{
            throw new Error("Cannot proceed right now because no shipping method was found."); 
          }

          if(this.taxAmount){
            equipment.push({
              make:"candela",
              model:"charge",
              handle:"tax-charges",
              id:"47396781949090",
              quantity:1,
              price: Number(this.taxAmount),
              cost: Number(this.taxAmount),
            })
          }


          const entity = {
            phone: `+1${this.getValue("#entityPhone").trim()}`,
            primaryContactEmail: this.getValue("#entityEmail").trim(),
            legalName: this.getValue("#entityName").trim(),
            businessOwnerName: this.getValue("#businessOwnerName").trim(),
            address: {
              street1: this.getValue("#entityStreet1").trim(),
              street2: this.getValue("#entityStreet2").trim(),
              city: this.getValue("#entityCity").trim(),
              state: this.getValue("#entityState").trim(),
              postalCode: this.getValue("#entityPostal").trim(),
              country: this.getValue("#entityCountry").trim()
            }
          };

          const selectedShippingMethod = this.querySelector('input[name="shipping_method"]:checked');
          const shippingMethod = selectedShippingMethod?.dataset.title || '';
          // const shippingRate = Number(selectedShippingMethod?.dataset.price || 0);
          const shippingRate = equipment.find((item) => item.handle === "shipping-charges")?.discountedPrice || 0;
          const taxAmount = this.taxAmount;

          // const party = {
          //   firstName: this.getValue("#firstName").trim(),
          //   lastName: this.getValue("#lastName").trim(),
          //   partyRole: this.getValue("#partyRole").trim(),
          //   entitySigner: this.getChecked("#EntitySigner"),
          //   phone: this.getValue("#phone").trim(),
          //   email: this.getValue("#email").trim(),
          //   street1: this.getValue("#partyStreet1").trim(),
          //   street2: this.getValue("#partyStreet2").trim(),
          //   city: this.getValue("#partyCity").trim(),
          //   state: this.getValue("#partyState").trim(),
          //   postalCode: this.getValue("#partyPostal").trim(),
          //   country: this.getValue("#partyCountry").trim()
          // };

          const shippingAddress = {
            firstName: this.getValue("#partyFirstName").trim(),
            lastName: this.getValue("#partyLastName").trim(),
            phone: `${this.getValue("#partyPhone").trim()}`,
            email: this.getValue("#entityEmail").trim(),
            street1: this.getValue("#partyStreet1").trim(),
            street2: this.getValue("#partyStreet2").trim(),
            city: this.getValue("#partyCity").trim(),
            state: this.getValue("#partyState").trim(),
            postalCode: this.getValue("#partyPostal").trim(),
            country: this.getValue("#partyCountry").trim()
          };

          const term = localStorage.getItem("emiPlan")?.split(" ")[0];
          // Down payment
          // const downPaymentPercentage = localStorage.getItem("downpayment")?.split("%")[0];

          // const financeProduct = {
          //   productCode: "FIN-" + term + "M",
          //   advanced: this.getChecked("#FinanceAdvanced"),
          //   term: parseInt(term),
          //   paymentFrequency: "MONTHLY",
          //   discountRate: parseFloat(this.getValue("#discountRate") || 0),
          //   downPayment: parseFloat(this.getValue("#downPayment") || 0),
          //   apr: term == "12" ? 0 : 6.99,
          //   downPaymentPercentage : term == "12" ? Number(downPaymentPercentage) : 0
          // };

          const financeProduct = {
            productCode: "FIN-" + term + "M",
            advanced: this.getChecked("#FinanceAdvanced"),
            term: parseInt(term),
            paymentFrequency: "MONTHLY",
            discountRate: parseFloat(this.getValue("#discountRate") || 0),
            apr: term == "12" ? 0 : 6.99,
            downPayment:0,
            downPaymentPercentage:0,
          };

          const payload = {
            externalIds: {
              // applicationId: this.getValue("#applicationId"),
              customerId: this.getValue("#clientId")
            },
            customerId: this.getValue("#clientId"),
            entity,
            shippingMethod,
            shippingRate,
            shippingAddress: shippingAddress,
            financeProduct,
            taxAmount,
            equipment
          };

          console.log("Payload:", payload);

          // ================= STEP 3: tax and shipping =================
          // const shippingAndTax = await this.calculateTaxAndShipping(payload);
          // this.setStepSuccess(this.steps.taxAndShipping);


          // ================= STEP 4: SUBMIT =================
          const response = await this.sendPayload(payload);
          const metafieldUpate = await this.updateMetafield(this.getValue("#clientId"));
          console.log("API Success:", response);

             // --- GA4 Financing TRACKING START ---
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'financing_application_submit'
            });

            // console.log('%c✅ FINANCING APPLICATION SUBMITTED:', 'color: #27ae60; font-weight: bold;', {
            //   event: 'financing_application_submit'
            // });
          } catch (e) {
            console.error('❌ GA4 Financing Application Submit Tracking Error:', e);
          }
          // --- GA4 Financing  TRACKING END ---

          this.response = response;

          this.setStepSuccess(this.steps.submit);

          // redirect to checkout with all discount
          // window.location.href ="/location"

          // Hide all current steps
          const warning = document.querySelector(".finance-info-box");

          if(warning){
            warning.setAttribute("hidden", true);
          }

          if(this.step1Tab && this.step1Content){
            this.step1Content.classList.remove("active");
            this.step1Tab.classList.remove("active");
          }

          if(this.financeApp){
            this.financeApp.setAttribute("hidden", true)
          }

          if(this.cartSummaryWrapper){
            this.cartSummaryWrapper.setAttribute("hidden", true)
          }

          if(this.financeAppInfo){
            this.financeAppInfo.setAttribute("hidden", true)
          }

          window.scrollTo({ top: 0, behavior: "smooth" });

          // OPTIONAL: close modal after delay
          setTimeout(() => {
            this.closeModal();
            // this.form.submit();
          }, 1000);


          // check the response for approval
          if(response.decision && response.decision.status == "REJECTED"){
            this.step6Rejected.classList.add("active");
            return;
          }

          // check
          if (response.dextCustomPopup && response.dextCustomPopup.ok) {
              const iframeSrc = response.dextCustomPopup.iframeSrcAbsolute;

              // Show step 4
              if (this.step4Content) {
                this.step4Content.removeAttribute("hidden");

                this.step4Content.innerHTML = `
                  <div class="finance-success p-0" style="padding:0px">
                    <iframe
                      src="${iframeSrc}"
                      width="100%"
                      height="1650"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                  </div>
                `;

                if(this.pageTitle){
                  this.pageTitle.setAttribute("hidden", "true");
                }
              }

              // Hide step 3 if needed
              if (this.step3Content && this.step3Tab) {
                this.step3Content.classList.remove("active");
                this.step3Tab.classList.remove("active");
              }

              if (this.step4Content) {
                this.step4Content.classList.add("active");
              }

               // --- GA4 financing_supplement_viewed tracking ---
                // Fires when the Supplemental Credit Application step (Dext iframe)
                // becomes the active panel.
                try {
                  const pushData = {
                    event: 'financing_supplement_viewed'
                  };

                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push(pushData);

                  // console.group('%c✅ GA4 EVENT: financing_supplement_viewed', 'background: #2980b9; color: #fff; padding: 2px 5px; font-weight: bold;');
                  // console.log('Payload Pushed:', pushData);
                  // console.log('Current dataLayer:', window.dataLayer);
                  // console.groupEnd();

                } catch (err) {
                  console.error('❌ GA4 financing_supplement_viewed Error:', err);
                }
                // --- end GA4 tracking ---
            }else{
              if(this.step5Pending){
                this.step5Pending.classList.add("active");
              }
            }

          

        } catch (err) {
          console.error(err);

          // if(this.step3Tab && this.step3Content){
          //   this.step3Content.classList.add("active");
          //   this.step3Tab.classList.add("active");
          // }

          // if(this.step1Tab && this.step1Content){
          //   this.step1Content.classList.remove("active");
          //   this.step1Tab.classList.remove("active");
          // }
          this.handleError(err);
        } finally {
          this.setLoading(false);
        }
      }


      /**
       * Helper function to inject an error message safely.
       */
      displayError(container, message) {
        const wrapper = container.querySelector(".discount-input-wrapper");
        
        const errorEl = document.createElement("span");
        errorEl.classList.add("discount-error");
        errorEl.textContent = message;
        
        if (wrapper) {
          wrapper.appendChild(errorEl);
          
        }
      }

      // ================= VALIDATION =================

      validateRequiredFields() {
        const requiredFields = this.form.querySelectorAll('[data-required="true"]');

        let firstInvalidField = null;

        requiredFields.forEach((field) => {
          const value = field.value?.trim();

          // remove previous error state
          field.classList.remove("field-error");

          // check empty value
          if (!value) {
            field.classList.add("field-error");

            // store first invalid field
            if (!firstInvalidField) {
              firstInvalidField = field;
            }
          }
        });

        // scroll to first invalid field
        if (firstInvalidField) {
          const offset = 140; // sticky header height

          const top =
            firstInvalidField.getBoundingClientRect().top +
            window.pageYOffset -
            offset;

          window.scrollTo({
            top,
            behavior: "smooth",
          });

          firstInvalidField.focus({ preventScroll: true });

          return false;
        }

        return true;
      }

      validateRequiredFieldsForShipping() {
        const requiredFields = this.form.querySelectorAll('.required-for-shipping');

        let firstInvalidField = null;

        requiredFields.forEach((field) => {
          const value = field.value?.trim();

          // remove previous error state
          field.classList.remove("field-error");

          // check empty value
          if (!value) {
            field.classList.add("field-error");

            // store first invalid field
            if (!firstInvalidField) {
              firstInvalidField = field;
            }
          }
        });

        return true;
      }

      async validateCart(){
        const cart = await this.getCart();
        if (!cart.items || cart.items.length === 0) {
          const error = new Error("Your cart is empty.");
          error.step = "cart";
          error.code = "EMPTY_CART";
          throw error;
        }

        if(cart.items.length > 0){
          let cartEligible = false
          for (const item of cart.items) {
            const productType = item.product_type?.trim().toLowerCase();
            if(productType == "system" || productType == "pto"){
              cartEligible = true;
              break;
            }
          }

          if (!cartEligible) {
            throw new Error("Please add System Product to your cart to proceed with application.");
          }
        }

        return cart;
      }

      
     validateInputs() {
      const email = this.getValue("#entityEmail").trim();

      // Email regex (practical, not over-strict)
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!email || !emailRegex.test(email)) {
        const field = this.querySelector("#entityEmail");
        field.classList.add("field-error");
        field.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        field.focus();
        throw new Error("Please enter a valid email address.");
      }

      const entityPhone = this.getValue("#entityPhone").trim();
      const phone = this.getValue("#partyPhone").trim();

      // ZIP codes
      const entityPostal = this.getValue("#entityPostal").trim();
      const partyPostal = this.getValue("#partyPostal").trim();

      // Remove spaces, dashes, brackets and dots before validation.
      // Keep a leading "+" so we can support +1.
      const normalizePhone = (value) =>
        value.replace(/[^\d+]/g, "");

      // accepts:
      // 5551234567
      // (555) 123-4567
      // 555-123-4567
      // 555 123 4567
      // 555.123.4567
      // +1 555-123-4567
      // 1-555-123-4567
      // 15551234567
      //
      // Rules:
      // - Optional US country code (1 or +1)
      // - Area code cannot start with 0 or 1
      // - Exchange code cannot start with 0 or 1
      const phoneRegex = /^(?:\+?1)?[2-9]\d{2}[2-9]\d{6}$/;

      // accepts:
      // 97070
      // 97070-3923
      const zipRegex = /^\d{5}(-\d{4})?$/;

      const normalizedEntityPhone = normalizePhone(entityPhone);
      const normalizedPhone = normalizePhone(phone);

      // Remove previous error styling
      [
        "#entityPhone",
        "#partyPhone",
        "#entityPostal",
        "#partyPostal",
      ].forEach((selector) => {
        this.querySelector(selector)?.classList.remove("field-error");
      });

      // Validate Company phone
      if (!entityPhone || !phoneRegex.test(normalizedEntityPhone)) {
        const field = this.querySelector("#entityPhone");
        field.classList.add("field-error");
        field.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        field.focus();

        throw new Error("Please enter a valid phone number.");
      }

      // Validate Applicant phone
      if (!phone || !phoneRegex.test(normalizedPhone)) {
        const field = this.querySelector("#partyPhone");
        field.classList.add("field-error");
        field.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        field.focus();

        throw new Error("Please enter a valid Applicant phone number.");
      }

      // Validate Company ZIP code
      if (!entityPostal || !zipRegex.test(entityPostal)) {
        const field = this.querySelector("#entityPostal");
        field.classList.add("field-error");
        field.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        field.focus();

        throw new Error(
          "Please enter a valid ZIP code."
        );
      }

      // Validate Applicant ZIP code
      if (!partyPostal || !zipRegex.test(partyPostal)) {
        const field = this.querySelector("#partyPostal");
        field.classList.add("field-error");
        field.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        field.focus();

        throw new Error(
          "Please enter a valid Applicant ZIP code."
        );
      }

      return true;
     }

      async calculateTaxAndShipping() {
        // e.preventDefault();
        if(this.shippingSection){
          this.shippingSection.setAttribute("hidden", true);
        }
        const isValid = this.validateRequiredFieldsForShipping();

        if (!isValid) {
          return
        };

        console.log("TRIGGERED")
        this.setLoading(true)
        try {
          const cart = await this.validateCart()

          // ================= BUILD DATA =================
          const equipment = cart.items.map(item => ({
            make: item.vendor,
            model: item.properties["_model"],
            serialNumber: item.sku,
            handle: item.handle,
            id:String(item.id),
            price: item.discounted_price / 100,
             cost: (item.line_price / 100),
            quantity: item.quantity
          }));

          const shippingAddress = {
            firstName: this.getValue("#partyFirstName").trim(),
            lastName: this.getValue("#partyLastName").trim(),
            phone: this.getValue("#partyPhone").trim(),
            email: this.getValue("#entityEmail").trim(),
            street1: this.getValue("#partyStreet1").trim(),
            street2: this.getValue("#partyStreet2").trim(),
            city: this.getValue("#partyCity").trim(),
            state: this.getValue("#partyState").trim(),
            postalCode: this.getValue("#partyPostal").trim(),
            country: this.getValue("#partyCountry").trim()
          };

          const payload = {
            customerId: this.getValue("#clientId"),
            shippingAddress: shippingAddress,
            equipment
          };

          this.shippingCalculated = false;
          const response = await fetch(
            `${this.baseUrl}/api/loan/calculateTaxAndShipping`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            }
          );

          if (!response.ok) {
            throw new Error("Failed to calculate tax and shipping.");
            this.shippingCalculated = false;
          }

          const data = await response.json();
          this.shippingCalculated = true;
          this.setLoading(false);
          this.submitBtn.textContent = "Review and Submit Application"

          const shippingAmount = Number(data.shippingAmount || 0);
          const taxAmount = Number(data.taxAmount || 0);
          const shippingMethods = data.shippingRates || []
          this.taxAmount = data.taxAmount;

          // update shipping charges
          await this.updateShippingCartLinePrice(shippingAmount)

          // ================= DOM ELEMENTS =================

          // const shippingElement = document.querySelectorAll(".cart-custom-calc-text")[0];
          // const taxElement = document.querySelectorAll(".cart-custom-calc-text")[1];

          // const shippingElement = document.querySelectorAll(".cart-custom-calc-text")[1];
          const taxElement = document.querySelectorAll(".cart-custom-calc-text")[0];
          const subtotalElement = document.querySelector(".cart-custom-summary-val");
          const totalElement = document.querySelector(".cart-custom-total-price");
          
           this.updateCartSummary({
              shippingAmount,
              taxAmount:taxAmount,
              shippingElement:
              document.querySelectorAll('.cart-custom-calc-text')[1],
              
              taxElement:
              document.querySelectorAll('.cart-custom-calc-text')[0],

              subtotalElement:
                document.querySelector('.cart-custom-summary-val'),

              totalElement:
                document.querySelector('.cart-custom-total-price'),
            });

          // ================= DOM ELEMENTS =================

          const shippingElement = document.querySelectorAll(".cart-custom-calc-text")[0];
          // const taxElement = document.querySelectorAll(".cart-custom-calc-text")[1];
          //const subtotalElement = document.querySelector(".cart-custom-summary-val");
          //const totalElement = document.querySelector(".cart-custom-total-price");

          // ================= GET SUBTOTAL =================

          let subtotal = 0;

          if (subtotalElement) {
            subtotal = Number(
              subtotalElement.textContent.replace(/[^0-9.]/g, "")
            );
          }

          // ================= UPDATE UI =================

          // if (shippingElement) {
          //   const shippingCost = shippingAmount || 0;
          //   shippingElement.textContent = formatMoney(shippingCost * 100,  window.theme.money_total_price_format);
          // }

          if (taxElement) {
            const textCost = taxAmount || 0;
            taxElement.textContent = formatMoney(textCost * 100,  window.theme.money_total_price_format);
          }

          // const total = subtotal + shippingAmount + taxAmount;
          const total = subtotal +  taxAmount;
          this.total = subtotal;

          // Down payment
          // if(this.cartDownpayment && this.cartDownpayment.querySelector(".cart-custom-downpayment")){
          //   const downpayment = total * (this.downPaymentPercentage/100);
          //   this.cartDownpayment.querySelector(".cart-custom-downpayment").innerText = formatMoney(downpayment * 100,  window.theme.money_total_price_format);

          // }

          if (totalElement) {
            totalElement.textContent = formatMoney(total * 100,  window.theme.money_total_price_format);
          }


        this.updateCost();

        // Add Blocks for shipping Rates

          const shippingWrapper = this.shippingSection.querySelector('.shipping-method-warpper');

          if (shippingMethods.length && shippingWrapper && this.shippingSection) {
            shippingWrapper.innerHTML = '';

            shippingMethods.forEach((method, index) => {
              const amount = Number(method.price?.amount || 0);

              const formattedPrice =
                amount === 0
                  ? 'Free'
                  : new Intl.NumberFormat('en-US', {
                      style: 'currency',
                      currency: method.price.currencyCode || 'USD',
                    }).format(amount);

              const shippingHTML = `
                <div class="shipping-method-card">
                   <input
                    type="radio"
                    name="shipping_method"
                    id="shipping-method-${index}"
                    value="${method.handle}"
                    data-title="${method.title}"
                    data-price="${amount}"
                    ${index === 0 ? 'checked' : ''}
                  >

                  <label for="shipping-method-${index}">
                    <div class="shipping-method-left">
                      <span class="shipping-radio"></span>

                      <div>
                        <div class="shipping-method-title">
                          ${method.title}
                        </div>
                      </div>
                    </div>

                    <div class="shipping-method-price">
                      ${formattedPrice}
                    </div>
                  </label>
                </div>
              `;

              shippingWrapper.insertAdjacentHTML('beforeend', shippingHTML);
            });

            this.shippingSection.removeAttribute('hidden');

           const shippingInputs = shippingWrapper.querySelectorAll(
              'input[name="shipping_method"]'
            );

            shippingInputs.forEach((input) => {
              input.addEventListener('change', async (event) => {

                this.setLoading(true);
                const selectedMethod = event.target;
                const shippingMehodName = selectedMethod.dataset.title;
                const shippingAmount = selectedMethod.dataset.price || "0"
                this.shippingAmount = shippingAmount;
                
                payload.shippingMethod = shippingMehodName;
                payload.shippingRate = shippingAmount;
                
                let updatedTaxAmount = await this.updateTaxCharges(payload);
                this.taxAmount = updatedTaxAmount;

                await this.updateShippingCartLinePrice(shippingAmount);

                this.updateCartSummary({
                  shippingAmount,
                  taxAmount:updatedTaxAmount,
                  shippingElement:
                    document.querySelectorAll('.cart-custom-calc-text')[1],

                  taxElement:
                    document.querySelectorAll('.cart-custom-calc-text')[0],

                  subtotalElement:
                    document.querySelector('.cart-custom-summary-val'),

                  totalElement:
                    document.querySelector('.cart-custom-total-price'),
                });

                this.setLoading(false);
                this.updateCost();

              });
            });

            // dispatch change event if first selected has amount

            const selectedDefaultInput = [shippingInputs].find((item) => item.checked && item.dataset.price !== '0');
            selectedDefaultInput?.dispatchEvent(new Event('change'));

          }

        } catch (error) {
          console.error("Tax & Shipping API Error:", error);
          this.setLoading(false);
          this.shippingSection.removeAttribute("hidden");
        }
      }

      async updateShippingCartLinePrice(newPrice) {
        console.log("Updating cart...");

        try {
          const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: this.shippingCartLineKey,
              quantity: 1,
              properties: {
                _shippingCharge: "true",
                _newPrice: newPrice,
              },
              sections: ["financing-form-cart-summary"],
              sections_url: window.location.pathname,
            }),
          });

          console.log("Response status:", response.status);

          if(response.status == 400){
            return;
          }
            const data = await response.json();
            const shippingCartLine = data.items.find(item => item.handle === "shipping-charges");
            if(shippingCartLine){
              this.shippingCartLineKey = shippingCartLine.key;
            }
            
            const html = data.sections?.["financing-form-cart-summary"];
            
            if (html) {
              const doc = new DOMParser().parseFromString(html, "text/html");
              
              const newSummary = doc.querySelector("aside.cart-custom-wrapper");
              const currentSummary = document.querySelector(
                "aside.cart-custom-wrapper"
              );
              
              if (newSummary && currentSummary) {
                currentSummary.innerHTML = newSummary.innerHTML;
              }
          }

          console.log("Cart updated successfully.");

          return data;
        } catch (error) {
          console.error("Failed to update cart:", error);
          throw error;
        }
      }

      // ================= API =================
      async sendPayload(payload) {
        const res = await fetch(`${this.baseUrl}/api/loan/apply`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          });

          const data = await res.json(); // 👈 THIS is your actual response

          if (!data.dextTransactionId) {
            throw new Error("Submission failed. Please try again.");
          }

          return data;
      }

      async updateMetafield(customerId) {
       const ENDPOINT = "https://www.mlveda.com/ShopifyApps/candelaFinanceAPI/api/customers/metafields"

        const data = {
          customerId,
          key: "finance_docu_signed",
          value: false
        };

        try {
          const response = await fetch(ENDPOINT, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
          });

          if (!response.ok) {
            throw new Error(`Request failed: ${response.status}`);
          }

          const result = await response.json();

          console.log("Metafield updated:", result);
          return result;
        } catch (error) {
          console.error("Failed to update metafield:", error);
          throw new Error('Failed to update the customer data');
        }
      }

      async getCart() {
        const res = await fetch("/cart.js");
        if (!res.ok) throw new Error("Failed to fetch cart");
        return res.json();
      }

      async updateTaxCharges(payload){
        const res = await fetch(`${this.baseUrl}/api/loan/calculateTax`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          });

          const data = await res.json(); // 👈 THIS is your actual response

          if (!data.taxAmount) {
            throw new Error("Error while calculating the tax amount.");
          }

          return data.taxAmount;
      }

      updateCartSummary({
          shippingAmount = 0,
          taxAmount = 0,
          shippingElement,
          taxElement,
          subtotalElement,
          totalElement,
        }) {
        // ================= GET SUBTOTAL =================

        let subtotal = 0;

        if (subtotalElement) {
            subtotal = Number(
              subtotalElement.textContent.replace(/[^0-9.]/g, '')
            );
          }

          // ================= UPDATE SHIPPING =================
          
          if (shippingElement) {
            const shippingCost = shippingAmount || 0;
            shippingElement.textContent = formatMoney(shippingCost * 100,  window.theme.money_total_price_format);
          }

          // ================= UPDATE TAX =================

          if (taxElement) {
            const textCost = taxAmount || 0;
            taxElement.textContent = formatMoney(textCost * 100,  window.theme.money_total_price_format);
          }

        // ================= UPDATE TOTAL =================

        const total = subtotal + Number(shippingAmount) + Number(taxAmount);

        if (totalElement) {
          totalElement.textContent = formatMoney(total * 100,  window.theme.money_total_price_format);
        }

        return total;
      }

      // ================= HELPERS =================
      getValue(selector) {
        return this.querySelector(selector)?.value || "";
      }

      getChecked(selector) {
        return this.querySelector(selector)?.checked || false;
      }

      setLoading(state) {
        if (!this.submitBtn) return;
        this.submitBtn.disabled = state;
        this.submitBtn.textContent = state ? "Processing..." : "Submit";
      }

      // ================= MODAL =================
      openModal() {
        this.modal.classList.add('active'); // NOT remove hidden
      }

      closeModal() {
        this.modal.classList.remove("active");
      }

      closeModal() {
        this.modal.classList.remove('active');
      }

      resetSteps() {
        Object.values(this.steps).forEach(step => {
          step.dataset.state = "loading";

          step.querySelector('.glace-step-error').classList.add('hidden');
          step.querySelector('.glace-step-error').textContent = '';

          this.setStepLoading(step);
        });
      }

      setStepLoading(step) {
        step.dataset.state = "loading";

        step.querySelector('.glace-step-icon').innerHTML = `
          <span class="btn-loader" style="display:block"></span>
        `;
      }

      setStepSuccess(step) {

        step.dataset.state = "success";

        step.querySelector('.glace-step-icon').innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path d="M5 13l4 4L19 7"
              stroke="#22c55e"
              stroke-width="2.5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"/>
          </svg>
        `;
      }

      setStepPending(step) {
        step.dataset.state = "pending";

        step.querySelector('.glace-step-icon').innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="9"
              stroke="#9ca3af"
              stroke-width="2"
              fill="none"
              stroke-dasharray="3 3"/>
          </svg>
        `;
      }

      setStepError(step, message) {
        step.dataset.state = "error";

        step.querySelector('.glace-step-icon').innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path d="M6 6l12 12M6 18L18 6"
              stroke="#ef4444"
              stroke-width="2.5"
              stroke-linecap="round"/>
          </svg>
        `;

        const err = step.querySelector('.glace-step-error');
        err.textContent = message;
        err.classList.remove('hidden');
      }

    handleError(err) {
      if(err.code == "EMPTY_CART"){
        document.querySelector("cart-restriction-modal")?.classList.add("active");
      }
      const stepsArray = Object.values(this.steps);

      // Find failed step
      const failedIndex = stepsArray.findIndex(
        step => step.dataset.state !== "success"
      );

      if (failedIndex !== -1) {
        // ❌ Set error on failed step
        this.setStepError(stepsArray[failedIndex], err.message);

        // ⏸ Set all NEXT steps as pending
        for (let i = failedIndex + 1; i < stepsArray.length; i++) {
          this.setStepPending(stepsArray[i]);
        }
      }
    }
  }

customElements.define("finance-form", FinanceForm);


class FinanceLink extends HTMLElement {
  connectedCallback() {
    const link = this.querySelector("a, button");

    if (!link) return;

    link.addEventListener("click", async (event) => {
      link.setAttribute('aria-busy', 'true');
      let href = null;
      if (link) {
        href =
          link.tagName === "A"
            ? link.getAttribute("href")
            : link.dataset.url;

        // console.log(url);
      }
      const action = this.dataset.action;

      event.preventDefault();

      // --- GA4 click_cta tracking: Financing Approved → Proceed to Checkout ---
      // Fires synchronously, before the await fetch below, so GTM has time
      // to send the hit before the eventual checkout redirect.
      // console.log('%c🔍 GA4 CHECK: click_cta condition', 'background: #95a5a6; color: #fff; padding: 2px 5px;', {
      //   'closest(.finance-success)': this.closest('.finance-success'),
      //   'href': href,
      //   'href includes /checkout': href?.includes('/checkout')
      // });

      if (this.closest('.finance-success') && href?.includes('/checkout')) {
        try {
          const elementText = link.textContent.trim();
          const elementLocation = 'financing_approved_state';

          const pushData = {
            event: 'click_cta',
            element_text: elementText,
            element_location: elementLocation
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(pushData);

          // console.group('%c✅ GA4 EVENT: click_cta (Financing Approved)', 'background: #27ae60; color: #fff; padding: 2px 5px; font-weight: bold;');
          // console.log('Element Text:', elementText);
          // console.log('Element Location:', elementLocation);
          // console.log('Payload Pushed:', pushData);
          // console.log('Current dataLayer:', window.dataLayer);
          // console.groupEnd();

        } catch (err) {
          console.error('❌ GA4 click_cta (Financing Approved) Error:', err);
        }
      } else {
        console.warn('⚠️ GA4 click_cta (Financing Approved): condition NOT met — event not fired.');
      }
     // --- end GA4 tracking ---
  
      const controls = this.closest(".cart__controls");
      if(controls){        
        const checkbox = controls.querySelector(".tac-checkbox");
        if(checkbox && !checkbox.checked){
          link.removeAttribute('aria-busy');
            checkbox.reportValidity();
            return;
          }
      }

      // Modal case
      if (action === "modal" && href === "#") {
        event.preventDefault();

        const modal = document.querySelector("cart-restriction-modal");
        modal?.classList.add("active");
        link.removeAttribute('aria-busy');
        return;
      }

      const attributes = {
        "Agree With TC": "yes",
        "Online": "true",
      };

      if(href?.includes("/checkout")){
        attributes["Financing"] = "yes";
      }

      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes }),
      });

      const cartData = await res.json();
      const items = cartData.items;

      const isSystemProduct = items.find(item => item.product_type.toLowerCase() == 'pto' || item.product_type.toLowerCase() == "system");
      if(isSystemProduct){
      // {% comment %} Hide charges {% endcomment %}
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: isSystemProduct.key,
            quantity: isSystemProduct.quantity,
            properties: {
              ...isSystemProduct.properties,
              "_Financing": "yes",
            },
          }),
        });

      }

      // Checkout case
      if (href?.includes("/checkout")) {
        event.preventDefault();
        try {

          window.location.href = href;
        } catch (error) {
          console.error("Error updating cart:", error);

          // Redirect anyway if request fails
          window.location.href = href;
        }

        // link.removeAttribute('aria-busy');
        return;
      }else{
        window.location.href = href;
      }

      // All other links (login, finance form, etc.)
      // proceed normally
    });

     const params = new URLSearchParams(window.location.search);

    if (params.get("financing") === "true") {
       // Remove the financing parameter from the URL
       params.delete("financing");
      if (link) {
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      }
    }

  }
}

if (!customElements.get("finance-link")) {
  customElements.define("finance-link", FinanceLink);
}


class ShopifyCartForm extends HTMLElement {
  constructor() {
    super();
    this.handleCheckoutClick = this.handleCheckoutClick.bind(this);
  }

  connectedCallback() {
    this.form = this.closest('form[action="/cart"]');

    if (!this.form) return;

    this.checkoutButton = this.form.querySelector('button[name="checkout"]');

    if (!this.checkoutButton) return;

    this.checkoutButton.addEventListener(
      "click",
      this.handleCheckoutClick,
    );
  }

  disconnectedCallback() {
    this.checkoutButton?.removeEventListener(
      "click",
      this.handleCheckoutClick,
    );
  }

  async handleCheckoutClick(event) {
    event.preventDefault();

    try {

        //  const controls = this.form.querySelector(".cart__controls");
        if(this.form){
          
          const checkbox = this.form.querySelector(".tac-checkbox");
          if(checkbox && !checkbox.checked){
              // link.removeAttribute('aria-busy');
              checkbox.reportValidity();
              return;
            }
        }

      // Update cart using the current form values (updates[], note, attributes, etc.)
      const formData = new FormData(this.form);

      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
      });

      if (!updateResponse.ok) {
        throw new Error("Failed to update cart.");
      }

      // Get the latest cart
      const cart = await fetch("/cart.js").then((res) => res.json());

      // Find PTO/System item with _Financing property
      const targetItem = cart.items.find((item) => {
        const productType = (item.product_type || "").toLowerCase();

        return (
          (productType === "pto" || productType === "system") &&
          item.properties &&
          Object.prototype.hasOwnProperty.call(item.properties, "_Financing")
        );
      });

      if (targetItem) {
        const properties = { ...(targetItem.properties || {}) };
        delete properties._Financing;

        const changeResponse = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: targetItem.key,
            quantity: targetItem.quantity,
            properties,
          }),
        });

        if (!changeResponse.ok) {
          throw new Error("Failed to remove _Financing property.");
        }
      }

      // Proceed to checkout
      window.location.href = "/checkout";
    } catch (error) {
      console.error(error);
      alert("Something went wrong while preparing your checkout. Please try again.");
    }
  }
}

customElements.define("shopify-cart-form", ShopifyCartForm);

 
class FinancingPaymentDropdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    const emiPlan =
      localStorage.getItem("emiPlan");

    if (emiPlan === "12 Months") {
      this.setAttribute("hidden", "");
      this.closest(".down-payment-card")?.setAttribute("hidden", true);
      
    } else {
      this.removeAttribute("hidden");
      this.closest(".down-payment-card")?.removeAttribute("hidden");
      // return;
    }

    // -----------------------------------
    // ELEMENTS
    // -----------------------------------

  //   this.select = this.querySelector(
  //     ".fin-custom-select"
  //   );

  //   this.trigger = this.querySelector(
  //     ".fin-custom-select-trigger"
  //   );

  //   this.options = this.querySelectorAll(
  //     ".fin-custom-option"
  //   );

  //   this.selectedText = this.querySelector(
  //     ".fin-selected-text"
  //   );

  //   this.hiddenInput = this.querySelector(
  //     ".fin-payment-hidden-input"
  //   );

  //   // -----------------------------------
  //   // EVENTS
  //   // -----------------------------------

  //   this.toggleDropdown =
  //     this.toggleDropdown.bind(this);

  //   this.handleOptionClick =
  //     this.handleOptionClick.bind(this);

  //   this.handleOutsideClick =
  //     this.handleOutsideClick.bind(this);

  //   if(this.trigger){
  //     this.trigger.addEventListener(
  //       "click",
  //       this.toggleDropdown
  //     );
  //   }

  //   if(this.options){
  //   this.options.forEach((option) => {
  //     option.addEventListener(
  //       "click",
  //       this.handleOptionClick
  //     );
  //   });
  // }

  //   document.addEventListener(
  //     "click",
  //     this.handleOutsideClick
  //   );

    // Trigger the first click event
    // const firstOption = this.options[0];
    // if(firstOption){
    //   firstOption.dispatchEvent(new Event("click"));
    // }
  }

  disconnectedCallback() {
    document.removeEventListener(
      "click",
      this.handleOutsideClick
    );
  }

  // toggleDropdown(event) {
  //   event.stopPropagation();

  //   this.select.classList.toggle("open");
  // }

  // handleOptionClick(event) {
  //   const option = event.currentTarget;

  //   // ACTIVE
  //   this.options.forEach((item) => {
  //     item.classList.remove("active");
  //   });

  //   option.classList.add("active");

  //   // UPDATE UI
  //   this.selectedText.textContent =
  //     option.dataset.label;

  //   this.hiddenInput.value =
  //     option.dataset.value;

  //   // SAVE
  //   localStorage.setItem(
  //     "downpayment",
  //     option.dataset.label
  //   );

  //   this.hiddenInput.dispatchEvent(
  //     new Event("change")
  //   );

  //   // CLOSE
  //   this.select.classList.remove("open");
  // }

  // handleOutsideClick(event) {
  //   if (!this.contains(event.target)) {
  //     this.select.classList.remove("open");
  //   }
  // }
}

customElements.define(
  "financing-payment-dropdown",
  FinancingPaymentDropdown
);

class CompleteFinanaceProcess extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");
    this.applicationId = this.dataset.applicationId;
    this.status = this.dataset.status?.toLowerCase();
    this.formContainer = document.querySelector(".finance-application-form");
    this.financeWrapper = document.getElementById("financeAppWrapper");
    this.trigger = false;

    if (!this.button) return;

    this.button.addEventListener("click", this.handleClick.bind(this));

    // Dext form submission message
    window.addEventListener("message", (event) => {
      
      // Check submitted event
      if (event.data?.type === "dx-form-submitted" && this.trigger) {
        console.log("Form submitted successfully");

        this.trigger = false;

        this.formContainer?.setAttribute("hidden", true);

       // Show pending state for not approved
        if (this.financeWrapper) {
          this.financeWrapper.removeAttribute("hidden");

          const app = this.financeWrapper.querySelector("#FinanceApp");
          if(app){
            app.setAttribute("hidden", true);
          }

          // Financing form
          const step1 = this.financeWrapper.querySelector(
            '.finance-step-content[data-step="1"]'
          );

          // Financing Approved
          const step3 = this.financeWrapper.querySelector(
            '.finance-step-content[data-step="3"]'
          );

          // Financing Pending
          const step5 = this.financeWrapper.querySelector(
            '.finance-step-content[data-step="5"]'
          );

          // Financing docusign
          const step7 = this.financeWrapper.querySelector(
            '.finance-step-content[data-step="7"]'
          );

          const cartWrapper = this.financeWrapper.querySelector(
            ".cart-custom-wrapper"
          );

          // Remove active class from all steps first
          this.financeWrapper
            .querySelectorAll(".finance-step-content")
            .forEach((step) => {
              step.classList.remove("active");
            });

          // Hide cart section
          cartWrapper?.classList.add("hidden");

          // No need for the pending or approved state
          // Pending state
          // if (this.status === "pending") {
          //   step1?.classList.remove("active");
          //   step5?.classList.add("active");
          // }

          // // // Approved state
          // if (this.status === "approved") {
          //   step1?.classList.remove("active");
          //   step3?.classList.add("active");
          // }

          // We are aksing for the docusign link
          step1?.classList.remove("active");
          step7?.classList.add("active");

        }
        // Scroll to top
        window.scrollTo({ top: 0, behavior: "smooth" });
  
        const warning = document.querySelector(".finance-info-box");
        if(warning){
          warning.setAttribute("hidden", true);
        }
      }

    });
  }

  async handleClick() {
    try {
      // Hide finance wrapper
      let API_ENDPOINT = 'https://www.mlveda.com/ShopifyApps/candelaFinanceAPI';

      switch (window.location.hostname) {
        case 'candela-medical-shop-fusion.myshopify.com':
          API_ENDPOINT = 'https://www.mlveda.com/ShopifyApps/CandelaFinanceFusionTest';
          break;
      
        default:
          break;
      }
      this.trigger = true;

      if (this.financeWrapper) {
        this.financeWrapper.setAttribute("hidden", "");
      }

      // Optional loading state
      this.button.disabled = true;
      this.button.textContent = "Loading...";

      // API call
      // const response = await fetch(
      //   `${API_ENDPOINT}/api/loan/dext-popup-by-application-id?applicationId=${this.applicationId}`
      // );

      // const data = await response.text();

      // if (!data?.url) {
      //   throw new Error("Unable to get application URL");
      // }

      // Show iframe container
      this.formContainer?.removeAttribute("hidden");
      setTimeout(() => {
        this.button.textContent = "Continue Financing Process";
      }, 500);

      // Render iframe
      // this.formContainer.innerHTML = data;
      // Render iframe
      // this.formContainer.innerHTML = `
      //   <iframe
      //     src="${API_ENDPOINT}/api/loan/dext-popup-by-application-id?applicationId=${this.applicationId}"
      //     width="100%"
      //     height="1650"
      //     frameborder="0"
      //     allowfullscreen
      //   ></iframe>
      // `;
      
    } catch (error) {
      console.error(error);

      this.button.disabled = false;
      this.button.textContent = "Continue Financing Process";
    }
  }
  
}

customElements.define(
  "complete-finanace-process",
  CompleteFinanaceProcess
);


class HoverButton extends HTMLButtonElement {
  constructor() {
    super();

    if (this.type === "submit" && this.form) {
      this.form.addEventListener("submit", () => {
        this.setAttribute("aria-busy", "true");
      });
    }

    this.append(this.animationElement);
     window.addEventListener("pagehide", () => {
      this.removeAttribute("aria-busy");
    });
  }

  static get observedAttributes() {
    return ["aria-busy"];
  }

  get contentElement() {
    return (
      this._contentElement ||
      (this._contentElement =
        this.querySelector(".btn-text") || this.firstElementChild || this)
    );
  }

  get animationElement() {
    if (!this._animationElement) {
      this._animationElement = document
        .createRange()
        .createContextualFragment(`
          <div class="theme-spinner theme-spinner--small theme-spinner--color-text">
            <div class="theme-spinner__border"></div>
            <div class="theme-spinner__border"></div>
            <div class="theme-spinner__border"></div>
            <div class="theme-spinner__border"></div>
          </div>
        `).firstElementChild;
    }

    return this._animationElement;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== "aria-busy" || oldValue === newValue) return;

    const busy = newValue === "true";

    this.contentElement?.animate(
      [
        { opacity: busy ? 1 : 0 },
        { opacity: busy ? 0 : 1 }
      ],
      {
        duration: 150,
        fill: "forwards"
      }
    );

    this.animationElement.animate(
      [
        { opacity: busy ? 0 : 1 },
        { opacity: busy ? 1 : 0 }
      ],
      {
        duration: 150,
        fill: "forwards"
      }
    );
  }
}

customElements.define("hover-button", HoverButton, {
  extends: "button",
});


class FinanceDiscountRemove extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onClick.bind(this));
  }

  async onClick(event) {
    const button = event.target.closest(".discount__remove");
    if (!button) return;

    // button.disabled = true;
    button.setAttribute("aria-busy", "true");

    const discounts = button.dataset.discount
      .split(",")
      .filter(code => code !== button.dataset.remove);

    try {
      const section = [this.dataset.section]
      const cart = await this.updateDiscounts(discounts, section);
      const html = cart.sections["financing-form-cart-summary"];

      const totalPrice = cart.total_price/100;
      const downPayment = document.querySelector("financing-payment-dropdown");
      if(downPayment){
        const input = downPayment.querySelector("input");
        const zeroButton = downPayment.querySelector("button[data-value='0']");
        const firstButton = downPayment.querySelector("button[data-value='10']");
        if(totalPrice > 64900 ){
          zeroButton.setAttribute("hidden", true);
          if(input.value == '0'){
            firstButton.dispatchEvent(new Event("click"));
          }
        }else{
          zeroButton.removeAttribute("hidden");
          zeroButton.classList.remove("active")
        }
      }

      // Refresh cart drawer/page as needed
      // window.location.reload();

      const doc = new DOMParser().parseFromString(html, "text/html");
      const newSummary = doc.querySelector("aside.cart-custom-wrapper");
      const currentSummary = document.querySelector("aside.cart-custom-wrapper");
      if(newSummary && currentSummary){
        currentSummary.innerHTML = newSummary.innerHTML;
      }

      const financeWrapper = document.querySelector("#financeAppWrapper");
      const financeForm = financeWrapper?.querySelector("finance-form")
      if (financeForm) {
        financeForm.calculateTaxAndShipping();
      }

    } catch (error) {
      console.error("Failed to remove discount", error);
      button.disabled = false;
    }
  }

  async updateDiscounts(discounts, sections) {
    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        discount: discounts.join(","),
        sections,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to update discounts");
    }

    return response.json();
  }
}

customElements.define("finance-item-discounts", FinanceDiscountRemove);


class FinanceDiscountApply extends HTMLElement {
  constructor() {
    super();
    // Discount inputs
        const inputElement = this.querySelector("#discount-code");
        const buttonElement = this.querySelector("#discount-apply-btn")
      if (inputElement && buttonElement) {
          // 1. Bind the toggle logic (existing)
          this.bindDiscountToggle(inputElement, buttonElement);

          // 2. Bind the apply logic to the button click
          buttonElement.addEventListener("click", async (event) => {
            event.preventDefault(); 
            const isDiscountValid = await this.handleDiscountApply(inputElement, buttonElement, this);
            const financeWrapper = document.querySelector("#financeAppWrapper");
            const financeForm = financeWrapper?.querySelector("finance-form")
            if (financeForm && isDiscountValid) {
              financeForm.calculateTaxAndShipping();
            }
          });
        }
    }

    bindDiscountToggle(inputElement, buttonElement) {
      // Safety check to prevent errors if elements aren't found
      if (!inputElement || !buttonElement) {
        console.warn("bindDiscountToggle: Input or button element is missing.");
        return;
      }

      inputElement.addEventListener("input", function() {
        const isDiscountExist = document.querySelector("finance-item-discounts")
        if (this.value.trim().length > 0 && !isDiscountExist) {
          buttonElement.removeAttribute("disabled");
        } else {
          buttonElement.setAttribute("disabled", "true");
        }
      });
    }

    async handleDiscountApply(inputElement, buttonElement, containerElement) {
      const code = inputElement.value.trim();
      if (!code) return false;

      // 1. Set loading states
      buttonElement.setAttribute("aria-busy", "true");
      const originalBtnText = buttonElement.textContent;
      // buttonElement.setAttribute("disabled", "true");
      // buttonElement.textContent = "Applying...";
      // buttonElement.setAttribute("aria-busy",true);

      // Clear any existing error messages
      const existingError = containerElement.querySelector(".discount-error");
      if (existingError) {
        existingError.remove();
      }

      try {
        // 2. Make the API call to Shopify to set the discount cookie
        const response = await fetch(`/discount/${code}`);
        console.log("DISCOUNT: RES: ", response)
        if (!response.ok) {
          throw new Error("Network response was not ok");
          return false;
        }

        // Refresh cart drawer/page as needed
        // window.location.reload();

        // 3. Strict Verification: Fetch the cart to see if Shopify accepted it
        const cart = await fetch("/cart.js").then((res) => res.json());

        const totalPrice = cart.total_price/100;
        const downPayment = document.querySelector("financing-payment-dropdown");
        if(downPayment){
          const input = downPayment.querySelector("input");
          const zeroButton = downPayment.querySelector("button[data-value='0']");
          const firstButton = downPayment.querySelector("button[data-value='10']");
          if(totalPrice > 64900){
            zeroButton.setAttribute("hidden", true);
            if(input.value == '0'){
              firstButton.dispatchEvent(new Event("click"));
            }
          }else{
             zeroButton.removeAttribute("hidden");
             zeroButton.classList.remove("active")
          }
        }
        // Check cart-level discounts
        const hasCartDiscount = (cart.cart_level_discount_applications || []).some(
          (discount) => discount.title.toLowerCase() === code.toLowerCase()
        );

        // Check line-item discounts
        const hasLineItemDiscount = (cart.items || []).some((item) =>
          (item.line_level_discount_allocations || []).some(
            (discount) =>
              discount.discount_application.title.toLowerCase() === code.toLowerCase()
          )
        );

        const isDiscountValid = hasCartDiscount || hasLineItemDiscount;

        if (!isDiscountValid) {
          throw new Error("Discount invalid or not applicable");
          return false;
        }

        const sectionId = "financing-form-cart-summary";

        const cartSummaryResponse = await fetch(
          `${window.location.pathname}?sections=${sectionId}`
        );

        if (!cartSummaryResponse.ok) {
          throw new Error(`Failed to render section: ${cartSummaryResponse.status}`);
          return false;
        }

        const sections = await cartSummaryResponse.json();
        const html = sections[sectionId];

        if (!html) {
          throw new Error(`Section "${sectionId}" not found.`);
          return false;
        }

        const doc = new DOMParser().parseFromString(html, "text/html");

        document.querySelector("aside.cart-custom-wrapper").innerHTML =
        doc.querySelector("aside.cart-custom-wrapper").innerHTML;

        // 4. Success State: Clear input, stop loading state
        // inputElement.value = "";
        buttonElement.removeAttribute("aria-busy");
        // buttonElement.textContent = originalBtnText;
        
        // (Optional) If you have a function to re-render the cart UI totals, call it here!
        // renderCartTotals(cart);
        return true;

      } catch (error) {
        console.log(error)
        // 5. Error State: Display error message
        this.displayError(containerElement, "Invalid discount code or not applicable to your cart.");
        
        // Reset button state so the user can try again
        buttonElement.removeAttribute("aria-busy");
        buttonElement.removeAttribute("disabled");
        // buttonElement.textContent = originalBtnText;
      }
    }

    displayError(container, message) {
        const wrapper = container.querySelector(".discount-input-wrapper");
        
        const errorEl = document.createElement("span");
        errorEl.classList.add("discount-error");
        errorEl.textContent = message;
        
        if (wrapper) {
          wrapper.appendChild(errorEl);
          
        }
      }

}

customElements.define("finance-discount", FinanceDiscountApply);

// Re-order feature
// Reorder feature
import Cart from "cart-store";

class ReorderData extends HTMLElement {
  constructor() {
    super();

    this.loader = this.querySelector("[data-reorder-loader]");
    this.cart = this.querySelector("interactive-cart");
    this.script = this.querySelector('script[type="application/json"]');
  }

  async connectedCallback() {
    const params = new URLSearchParams(window.location.search);

    if (!params.has("cart_link_id") && this.dataset.reorder == "true") {
      this.hideLoader();
      this.showCart();
      return;
    }

    this.showLoader();
    this.hideCart();

    try {
      const data = this.getData();

      
      await Cart.clear();
      
      if (data?.items?.length) {
        const dataItems = data.items.filter(item => item.handle != "shipping-charges" || item.handle != "tax-charges")
        // await this.addItems(data.items);
        await Cart.add(dataItems);

        await Cart.refresh();
      }

      // await this.renderCart();

      params.delete("cart_link_id");
      history.replaceState(
        {},
        "",
        `${window.location.pathname}${
          params.toString() ? `?${params}` : ""
        }`
      );
    } catch (error) {
      console.error("Reorder failed:", error);
    } finally {
      this.hideLoader();
      this.showCart();
    }
  }

  getData() {
    if (!this.script) return null;

    try {
      return JSON.parse(this.script.textContent);
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async clearCart() {
    const response = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to clear cart.");
    }
  }

  async addItems(items) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items,
        sections: ["main-cart"],
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add cart items.");
    }

    const data = await response.json();

    if (data.sections?.["main-cart"]) {
      const doc = new DOMParser().parseFromString(
        data.sections["main-cart"],
        "text/html"
      );

      const updatedCart = doc.querySelector('interactive-cart');
      const currentCart = this.querySelector('interactive-cart');
      
      if (updatedCart && currentCart) {
        currentCart.innerHTML = updatedCart.innerHTML;

        // OR if you want to replace the whole element:
        // currentCart.replaceWith(updatedCart);
      }
    }
  }

  showLoader() {
    if (this.loader) {
      this.loader.hidden = false;
    }
  }

  hideLoader() {
    if (this.loader) {
      this.loader.hidden = true;
    }
  }

  showCart() {
    if (this.cart) {
      this.cart.hidden = false;
    }
  }

  hideCart() {
    if (this.cart) {
      this.cart.hidden = true;
    }
  }
}

customElements.define("reorder-data", ReorderData);


class LoginMessage extends HTMLElement {
  connectedCallback() {
    const params = new URLSearchParams(window.location.search);

    if (params.get("login-message") === "true") {
      this.removeAttribute("hidden");
    } else {
      this.setAttribute("hidden", "");
    }
  }
}

customElements.define("login-message", LoginMessage);


class DocusignLink extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");

    if (!this.button) return;

    this.button.addEventListener("click", this.handleClick.bind(this));
  }

  async handleClick(event) {
    event.preventDefault();

    try {
      this.button.setAttribute('aria-busy', true);
      this.button.disabled = true;

      // Get Shopify customer ID
      const customerId = this.dataset.id;
      const API_ENDPOINT = "https://www.mlveda.com/ShopifyApps/candelaFinanceAPI";

      if (!customerId) {
        throw new Error("Customer ID not found.");
      }

      const response = await fetch(
        `${API_ENDPOINT}/api/loan/fetchDocusignUrl?customerId=${customerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch DocuSign URL.");
      }

      const data = await response.json();

      const docusignURL = data?.docusignURL;

      if (!docusignURL) {
        throw new Error("DocuSign link is unavailable.");
      }

      //  await this.updateDocusignLink(docusignURL, customerId);

      // Open DocuSign in the same window
      // window.location.href = docusignURL;
       if (docusignURL) {
        const link = document.createElement('a');

        link.href = docusignURL;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';

        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.error("DocuSign API Error:", error);

      this.showError(
        error?.message ||
        "Something went wrong while fetching the DocuSign link."
      );
    } finally {
      this.button.setAttribute('aria-busy', false);
      this.button.disabled = true;
    }
  }

  async updateDocusignLink(docusignURL, customerId){
    const ENDPOINT = "https://www.mlveda.com/ShopifyApps/candelaFinanceAPI/api/customers/metafields"

    const data = {
      customerId: customerId,
      key: "finance_docusign_link",
      value: docusignURL
    };

    try {
      const response = await fetch(ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }

      const result = await response.json();

      console.log("Metafield updated:", result);
      return result;
    } catch (error) {
      console.error("Failed to update metafield:", error);
      throw new Error('Failed to update the customer data');
    }
  }

  showError(message) {
    console.error(message);

    // Find or create error element
    let errorElement = this.querySelector(".docusign-error");

    if (!errorElement) {
      errorElement = document.createElement("div");
      errorElement.className = "docusign-error";
      this.appendChild(errorElement);
    }

    errorElement.textContent = message;
  }
}

if (!customElements.get("docusign-link")) {
  customElements.define("docusign-link", DocusignLink);
}

// Added By MLVeda: end